import React from 'react';
import { useController } from 'react-hook-form';

// components
import FormFieldLabel from '../FormFieldLabel';
import FormFieldError from '../FormFieldError';
import FormFieldDescription from '../FormFieldDescription';
import PlusIcon from '../../../../icons/PlusIcon';

const FileUpload = ({ name, control, rules, label, accept, multiple = false, description, ...props }) => {
    const {
        field: { value, onChange },
        fieldState: { error }
    } = useController({
        name,
        control,
        rules,
        defaultValue: null
    });

    const handleFileChange = (e) => {
        const files = e.target.files;
        if (multiple) {
            onChange(files ? Array.from(files) : []);
        } else {
            onChange(files && files[0] ? files[0] : null);
        }
    };

    const handleClick = () => {
        document.getElementById(name).click();
    };

    const getDisplayText = () => {
        if (!value) {
            return 'Scegli un file';
        }

        if (multiple && Array.isArray(value)) {
            if (value.length === 0) {
                return 'Scegli un file';
            } else if (value.length === 1) {
                return value[0].name;
            } else {
                return `${value.length} file selezionati`;
            }
        }

        return value.name || 'File selezionato';
    };

    const hasFile = multiple ? (Array.isArray(value) && value.length > 0) : !!value;
    const hasMultipleFiles = multiple && Array.isArray(value) && value.length > 1;

    return (
        <div className={`FormField FormField--fileupload ${error ? 'FormField--error' : ''}`}>
            <FormFieldLabel label={label} name={name} rules={rules}/>
            <div
                className="FormField__fileuploadInner"
                onClick={handleClick}
                role="button"
                tabIndex={0}
                data-has-file={hasFile}
                data-multiple-files={hasMultipleFiles}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        handleClick();
                    }
                }}
            >
                <input
                    {...props}
                    id={name}
                    type="file"
                    accept={accept}
                    multiple={multiple}
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                />
                <span className="FormField__fileuploadText">
          {getDisplayText()}
        </span>
                <PlusIcon/>
            </div>
            {error ? (
                <FormFieldError error={error} />
            ) : (
                <FormFieldDescription description={description} />
            )}
        </div>
    );
};

export default FileUpload;

/* Multiple fields example:
<FormField
  type="fileupload"
  name="documents"
  control={control}
  label="Documents"
  multiple={true}
  accept=".pdf,.doc,.docx"
  rules={{
    required: 'Please select at least one document',
    validate: {
      maxFiles: (files) =>
        !files || files.length <= 5 || 'Maximum 5 files allowed',
      fileSize: (file) =>
        !file || file.size <= 2000000 || 'File size must be less than 2MB'
    }
  }}
/>
 */